export default {
  0: '等待支付',
  1: '订单结束：用户取消',
  2: '制作中',
  3: '订单结束：审核未通过',
  4: '制作中',
  5: '订单结束：人工关闭',
  6: '验收评价',
  7: '返工中',
  8: '订单结束：已退款',
  9: '上传中',
  10: '订单完成',
  15: '订单完成：部分退款',
  16: '订单结束：用户手动取消',
  19: '订单结束：系统自动结束',
  20: '订单结束：用户放弃成品',
  21: '等待支付尾款',
  23: '待派单'
};
